exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".modal-inform.modal.in .modal-dialog{height:100%;transform:translate(0, 20%)}.modal-inform .modal-content{height:200px;padding:25px}.modal-inform .btn-ok{position:absolute;bottom:20px;right:50%;transform:translateX(50%)}.modal-inform__text-content{margin:45px 0;text-align:center;font-size:16px;color:#575757}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/modal-inform/style.scss
// module id = 1732
// module chunks = 32